// Copyright ©️ 2026 eVolve MEP, LLC

import { useMemo } from 'react';

import { PRODUCT_IDS } from 'constants/globalConstants';
import { useEvolveGetWithLocalStorage } from 'hooks/useEvolveGetWithLocalStorage';

/**
 * Used to get (cached) conduit bend types for fabrication.
 *
 * @remarks Only pulls types and sizes if the user has a Fabrication License.
 * */
export const useBendTypes = () => {
  const { data: bendTypes, loading } = useEvolveGetWithLocalStorage('shop/fabrication/bendTypes', {
    requireLicense: PRODUCT_IDS.FABRICATION_LICENSE,
  });

  return useMemo(
    () => ({
      bendTypes,
      loading,
    }),
    [bendTypes, loading],
  );
};
